import { Loading } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { HighchartsChart } from "@opendash/plugin-highcharts";
import { Typography } from "antd";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { TicketManager } from "../../..";
import { Kanban_State } from "../../../../../js/parsegenerated";

type Props = {
  ticketManager: TicketManager;
};

export const OverviewChart = observer((props: Props) => {
  const t = useTranslation();

  const ticketStateCount = useMemo(() => {
    const stateMap = new Map<string, { count: number; state: Kanban_State }>();
    for (const { state } of props.ticketManager.data) {
      const currentValue = stateMap.get(state.id);
      if (!currentValue) stateMap.set(state.id, { count: 1, state });
      else currentValue.count++;
    }

    return Array.from(stateMap.values()).sort((a, b) =>
      a.state.get("order") > b.state.get("order") ? 1 : -1
    );
  }, [props.ticketManager.data]);

  const options: Highcharts.Options = {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
    },
    title: {
      text: t("maintenance:ticket.statistic.overview.states"),
    },
    subtitle: {
      text: t("maintenance:ticket.statistic.total", {
        count: props.ticketManager.totalCount,
      }),
    },
    plotOptions: {
      pie: {
        innerSize: "80%",
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        type: "pie",
        data: ticketStateCount.map((d) => [d.state.get("label"), d.count]),
        name: "Tickets",
        colors: ticketStateCount.map((d) => d.state.get("color")),
      },
    ],
  };

  return (
    <>
      {props.ticketManager.loading && (
        <Loading message={t("maintenance:ticket.statistic.loading")} />
      )}
      {!props.ticketManager.loading && props.ticketManager.totalCount <= 0 && (
        <Typography.Text>
          {t("maintenance:ticket.statistic.noTickets")}
        </Typography.Text>
      )}
      {!props.ticketManager.loading && props.ticketManager.totalCount > 0 && (
        <HighchartsChart options={options} />
      )}
    </>
  );
});
